module.exports = __webpack_public_path__ + "f3c16d0c6511e8c8d5f4845abbd6be51.png";